module.exports = __webpack_public_path__ + "img/MRT_privilege_plus.d9c22d1e.jpg";